import api from './api';

const flightManagementService = {
  // Get all flights for airliner
  getFlights: async (params = {}) => {
    const response = await api.get('/flight-management', { params });
    return response;
  },

  // Get single flight details
  getFlightById: async (id) => {
    const response = await api.get(`/flight-management/${id}`);
    return response;
  },

  // Alias for getFlightById
  getFlightDetails: async (id) => {
    const response = await api.get(`/flight-management/${id}`);
    return response;
  },

  // Create new flight
  createFlight: async (data) => {
    const response = await api.post('/flight-management', data);
    return response;
  },

  // Update flight
  updateFlight: async (id, data) => {
    const response = await api.put(`/flight-management/${id}`, data);
    return response;
  },

  // Delete flight (soft delete)
  deleteFlight: async (id) => {
    const response = await api.delete(`/flight-management/${id}`);
    return response;
  },

  // Restore deleted flight
  restoreFlight: async (id) => {
    const response = await api.post(`/flight-management/${id}/restore`);
    return response;
  },

  // Permanently delete flight (force delete)
  permanentDeleteFlight: async (id) => {
    const response = await api.delete(`/flight-management/${id}/permanent`);
    return response;
  },

  // Export flights
  exportFlights: async (format = 'excel') => {
    const response = await api.get(`/flight-management/export/${format}`, {
      responseType: 'blob'
    });
    return response;
  },

  // Cancel flight — throw on API failure so callers never treat errors as success
  cancelFlight: async (id) => {
    const response = await api.post(`/flight-management/${id}/cancel`);
    if (response?.success === false) {
      const err = new Error(response.message || 'Failed to cancel flight');
      err.data = response;
      throw err;
    }
    return response;
  },

  // Get flight bookings
  getFlightBookings: async (id) => {
    const response = await api.get(`/flight-management/${id}/bookings`);
    return response;
  },

  // Publish flight (change status from draft to published)
  publishFlight: async (id) => {
    const response = await api.post(`/flight-management/${id}/publish`);
    return response;
  },

  // Save flight as draft
  saveDraft: async (data) => {
    const response = await api.post('/flight-management/draft', data);
    return response;
  },

  // TC-PJO-028: Get bookings pending PJO confirmation (only active pending bookings)
  getPendingConfirmationBookings: async () => {
    const response = await api.get('/flight-management/bookings/pending-confirmation');
    return response;
  },

  // TC-PJO-028: Get auto-expired booking history with pagination
  getAutoExpiredBookingHistory: async (page = 1, limit = 20) => {
    const response = await api.get('/flight-management/bookings/history/auto-expired', {
      params: { page, limit }
    });
    return response;
  },

  // TC-PJO-028: Accept a booking
  acceptBooking: async (bookingToken) => {
    const response = await api.post(`/flight-management/bookings/${bookingToken}/accept`);
    return response;
  },

  // TC-PJO-028: Reject a booking
  rejectBooking: async (bookingToken, reason = '') => {
    const response = await api.post(`/flight-management/bookings/${bookingToken}/reject`, { reason });
    return response;
  },

  // Add/Update booking notes
  updateBookingNotes: async (bookingToken, notes) => {
    const response = await api.post(`/bookings/${bookingToken}/notes`, { notes });
    return response;
  },

  // Request booking cancellation (sends notification to admin)
  requestBookingCancellation: async (bookingToken, reason) => {
    const response = await api.post(`/bookings/${bookingToken}/request-cancellation`, {
      reason: reason
    });
    return response;
  },

  // Direct cancel booking (for Admin)
  cancelBookingDirect: async (bookingToken, reason) => {
    const response = await api.post(`/bookings/cancel/${bookingToken}`, {
      reason: reason
    });
    return response;
  }
};

export default flightManagementService;
